<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'Cobrança Externa',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <form class="bs-example form-horizontal form-grv">
              <div class="bg-light lter b-b wrapper-md">
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <h1 class="font-thin h3">
                      Dados para Retirada / Pagamento
                    </h1>
                  </div>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="clearfix">

                  <div class="wrapper">
                    <div class="panel-body">

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Grv</label>
                        <div class="col-sm-10">
                          <select class="form-control">
                            <option value=""></option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Data pagamento</label>
                        <div class="col-sm-10">
                          <input type="" name="" class="form-control">
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Número documento</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-10">
                              <input type="" name="" class="form-control">
                            </div>
                            <div class="col-sm-2">
                              <button class="btn btn-info btn-md m-l-xs pull-right">Consultar</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Valor documento</label>
                        <div class="col-sm-10">
                          <input type="" name="" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Dados do Pagador
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label class="col-sm-2 control-label">Nome</label>
                        <div class="col-sm-10">
                          <input type="" name="" class="form-control">
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Tipo documento</label>
                        <div class="col-sm-10">
                          <select class="form-control">
                            <option value="">CPF</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Número documento</label>
                        <div class="col-sm-10">
                          <input type="" name="" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h1 class="font-thin h3">
                          Endereço Pagador
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                      <div class="panel-body">
                        <div class="form-group">
                          <label class="col-sm-2 control-label">CEP</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Endereço</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Número</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Complemento</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Bairro</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Cidade</label>
                          <div class="col-sm-10">
                            <input type="" name="" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Estado</label>
                          <div class="col-sm-10">
                            <select class="form-control">
                              <option value="">Rio de Janeiro</option>
                            </select>
                          </div>
                        </div>

                      </div>
                    </div>

                    <!---->
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Cobrancas
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                        <thead>
                          <tr>
                            <th>Tipo</th>
                            <th>Vencimento</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                            <th>Desconto</th>
                            <th>Status</th>
                            <th>Atalho</th>
                            <th>Detalhes</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="row">
                          <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv">Salvar</button>
                          <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e adicionar outro(a)</button>
                          <button class="btn btn-info btn-md m-l-xs btn-colsultaGrv">Salvar e continuar editando</button>
                        </div>
                      </div>
                    </div>


                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// CobrancaExterna.vue?638678ea